/**
 * Route: /hotspots/:id — W1.3
 *
 * validateSearch definiert erlaubten tab-Param.
 * Bindet HotspotDetail-Page ein.
 *
 * Seit 09.2026 liegt diese Route bewusst AUSSERHALB von `_auth`. In v1 waren
 * die Hotspot-Seiten oeffentlich, rund 100.000 davon lagen im Google-Index,
 * und die Besucher aus der Suche liefen in v2 gegen eine Login-Wand. Der
 * Endpunkt liefert Anonymen `is_owner: false`; HotspotDetail blendet damit
 * die besitzerexklusiven Reiter und Bloecke ohnehin schon aus (Issue web#97)
 * und setzt Titel, Canonical und JSON-LD selbst.
 *
 * Angemeldete Besucher bekommen weiterhin die volle AppShell mit Seitenleiste,
 * anonyme den schlanken PublicPageShell.
 */
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { HotspotDetail } from '../features/hotspots/HotspotDetail'
import { PublicOrAppShell } from '../layouts/PublicOrAppShell'

// Stories 1.5 + 1.6: neue Tab-Werte transfer/rewards/poc; die Legacy-Werte
// performance/speedtests bleiben für alte Deep-Links gültig und landen im
// Tab „Rewards & Aktivität", poc-archive im Tab „PoC-Archiv"
// (Mapping in HotspotDetail.normalizeDetailTab).
// W3-Gegentest BUG 1: .catch() statt .default() — ein unbekannter tab-Wert
// (z. B. Tippfehler im Deep-Link) darf NIE crashen, sondern fällt still auf
// den Default-Tab zurück. .catch deckt auch den fehlenden Param mit ab.
export const hotspotDetailSearchSchema = z.object({
  tab: z
    .enum(['transfer', 'rewards', 'splits', 'guard', 'poc', 'poc-archive', 'notes', 'performance', 'speedtests'])
    .catch('rewards'),
})

export const Route = createFileRoute('/hotspots/$id')({
  validateSearch: hotspotDetailSearchSchema,
  component: HotspotDetailPage,
})

function HotspotDetailPage() {
  const { id } = Route.useParams()
  const search = Route.useSearch()

  return (
    <PublicOrAppShell>
      <HotspotDetail id={id} tab={search.tab} />
    </PublicOrAppShell>
  )
}
